import { render, staticRenderFns } from "./_DocumentScannerFullscreen.vue?vue&type=template&id=f8b68aa6&scoped=true&"
import script from "./_DocumentScannerFullscreen.vue?vue&type=script&lang=js&"
export * from "./_DocumentScannerFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./_DocumentScannerFullscreen.vue?vue&type=style&index=0&id=f8b68aa6&prod&lang=scss&scoped=true&"
import style1 from "./_DocumentScannerFullscreen.vue?vue&type=style&index=1&id=f8b68aa6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b68aa6",
  null
  
)

export default component.exports